<template>
  <div class="special_detail_container">
    <!-- indexMode 1普通模式 2飞卡模式 -->
    <!-- classfyStyleMode 1tab 2锚点 -->
    <template001 :detail="detail" :contentId="contentId"
      v-if="!!contentId && !!detail && detail.indexMode == 1 && detail.classfyStyleMode == 1"></template001>
    <template002 :detail="detail" :contentId="contentId"
      v-else-if="!!contentId && !!detail && detail.indexMode == 1 && detail.classfyStyleMode == 2"></template002>
    <template003 :detail="detail" :contentId="contentId" v-else-if="!!contentId && !!detail && detail.indexMode == 2">
    </template003>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { loadStat, clickPlayCount } from "@/utils";
import specialApi from "@/api/apis/special.js";
import commApi from "@/api/apis/common.js";
import { qtSendPV } from "@/utils/qt.js";
import template001 from "./components/template001";
import template002 from "./components/template002";
import template003 from "./components/template003";
export default {
  name: "SpecialDetail",
  components: {
    template001,
    template002,
    template003,
  },
  data() {
    return {
      contentId: null,
      detail: null,
      shareUrl: "",
    };
  },
  computed: {
    ...mapState("app", ["userInfo", "nodeCode"]),
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.path == "/index_share") {
        vm.shareUrl = location.href.replace("/special_detail?", "/index_share?");
      } else {
        vm.shareUrl = location.href;
      }
    });
  },
  methods: {
    /* 微信二次分享 */
    wechatShare() {
      var _this = this;

      commApi.getWeiXinTicket({
        nodeCode: _this.nodeCode,
        url: _this.shareUrl
      }).then((res) => {
        _this.$WeiXin.shareWeiXin(res, _this.detail.specialTitle + " - 法治号客户端", _this.detail.introduction, _this.shareUrl, _this.detail.sharePictureUrl);
      }).catch((err) => {
      })
    },
    /* 获取专题 */
    getSpecialContentById() {
      var _this = this;
      var params = { contentId: _this.contentId };
      params.shareSign = this.$route.query.shareSign 
      params.timestamp = this.$route.query.timestamp
      specialApi
        .getSpecialContentById(params)
        .then((res) => {
          if (res.suc == 1) {
            document.title = res.data.specialTitle;
            _this.detail = res.data;
            _this.wechatShare(); // 微信二次分享
            _this.statistics(); // 统计
            // _this.trackHomePage(); // QT 首页浏览埋点
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 统计 */
    statistics() {
      let tj_params = {
        contentCreationTime: this.detail.contentCreationTime, // 创建时间
        contentId: this.detail.id, // 专题Id
        contentTitle: this.detail.specialTitle,
        contentType: 7,
        memberId: this.detail.memberId, // 当前稿件的编辑者的id
        nickName: this.detail.nickName, // 当前稿件的编辑者的用户名称
      }
      if (!!this.detail.channelId && this.detail.channelId > 0) {
        tj_params = Object.assign(tj_params, {
          channelId: this.detail.channelId, // 栏目id
          channelName: this.detail.channelName, // 栏目名称
        });
      }
      clickPlayCount(tj_params);
    },
    /* QT 首页浏览埋点 */
    trackHomePage() {
      qtSendPV("home_pg", {
        current_page_name: this.detail.specialTitle || "",
        current_page_id: String(this.detail.id || ""),
        current_channel_name: this.detail.channelName || "专题",
      });
    },
  },
  created() {
    let query = this.$route.query;
    if (Object.prototype.hasOwnProperty.call(query, "contentId")) {
      this.contentId = Number(query.contentId);
      this.getSpecialContentById(); //获取专题
      loadStat(); // 友盟统计
    } else {
      this.$router.replace({
        path: "/error",
      });
    }
  },
};
</script>
<style scoped lang="scss">
.special_detail_container {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>